import ActivityTab from "../../../../../../components/ServicesAndActivitesPage/ActivityTab";
export default ActivityTab;